import React, { useEffect, useRef, useState } from 'react'
import { MAIN_URL, getApiCall, postApiCall, postFormApiCall } from '../../utils/api';
import MaterialTable from 'material-table';
import tableIcons from '../component/MaterialIcon';
import { ThemeProvider, Typography, createTheme } from '@mui/material';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';


const QuizImage = () => {

    const defaultMaterialTheme = createTheme();
    const [selectedRow, setSelectedRow] = useState(null);
    const inputRef = useRef(null);
    const [loading, setLoading] = useState(false)

    const [data, setData] = useState([])

    const [boardList, setBoardList] = useState([])
    const [languageList, setLanguageList] = useState([])
    const [classList, setClassList] = useState([])

    const [boardName, setBoardName] = useState("")
    const [languageName, setLanguageName] = useState("")
    const [className, setClassName] = useState("")

    const [imageFile, setImageFile] = useState(null)
    const imageFileInputRef = useRef(null);

    const [isForAll, setIsForAll] = useState(false)


    useEffect(() => {
        fetchData()
    }, [])

    const formRef = useRef();
    const fetchData = async () => {
        setLoading(true)
        const boardRes = await getApiCall("board/get/all")
        setBoardList(boardRes.data);

        const res = await getApiCall("quiz/get/image");
        setData(res.data);
        res.data.forEach((data, index) => { data.serial = index + 1; });
        setLoading(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        const formData = new FormData();
        formData.append('board_id', boardName);
        formData.append('class_id', className);
        formData.append('language_id', languageName);
        formData.append('image', imageFile);
        formData.append('isForAll', isForAll);

        const res = await postFormApiCall("quiz/add/image", formData)

        setLoading(false)
        if (res.error === true) {
            return Swal.fire({
                title: 'Error',
                text: res.message,
                icon: 'error'
            });
        }
        Swal.fire({
            title: 'Successful',
            text: res.message,
            icon: 'success'
        });

        if (imageFileInputRef.current) {
            imageFileInputRef.current.value = '';
        }

        setBoardName("")
        setClassName("")
        fetchData()
    }

    const onBoardChange = async (val) => {
        setLoading(true)
        const boardRes = await postApiCall("language/get/byBoard", { "id": val })
        setLanguageList(boardRes.data);
        setLoading(false)
    }
    const onLanguageChange = async (val) => {
        setLoading(true)
        const langResponse = await postApiCall("class/get/byBoardAndMedium", { "board_id": boardName, "medium_id": val, })
        setClassList(langResponse.data);
        setLoading(false)
    }


    const columns = [
        { title: "Sl. no", field: "serial" },
        { title: "Board", field: "board_name" },
        { title: "Language", field: "language_name" },
        { title: "Class", field: "class_name" },
        {
            title: "Image", field: "image_path",
            render: (rowData) => {
                return (
                    <>
                        <img src={MAIN_URL + rowData.image_path} height={70} width={70} /></>
                )
            }
        },
    ]




    return (
        <div>
            <CircleSpinnerOverlay
                loading={loading}
                overlayColor="rgba(0,153,255,0.2)"
            />
            <div className='content-wrapper'>

                <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h4 className="m-0">Quiz Image</h4>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Quiz Image</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>


                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            {/* left column */}
                            <div className="col-md-12 mt-4">
                                {/* general form elements */}
                                <div className="card card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title">Add Quiz Image</h3>
                                    </div>
                                    <form onSubmit={handleSubmit} enctype="multipart/form-data">
                                        <div className="card-body">
                                            <div className="row">

                                                <div className="col-md-12 col-sm-12">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            checked={isForAll}
                                                            onChange={(e) => setIsForAll(e.target.checked)}
                                                        />
                                                        <span className='active-status'>For All?</span>
                                                    </label>
                                                </div>

                                                {!isForAll &&
                                                    <><div className="col-md-4 col-sm-12">
                                                        <div class="form-group">
                                                            <label for="selectInput">Select Board</label>
                                                            <select
                                                                class="custom-select form-select rounded-0"
                                                                id="selectInput"
                                                                onChange={(e) => {
                                                                    setBoardName(e.target.value)
                                                                    setLanguageName("")
                                                                    setClassName("")
                                                                    onBoardChange(e.target.value)
                                                                }}
                                                                required
                                                                value={boardName}
                                                                name='board_id'
                                                            >
                                                                <option value="" disabled selected>
                                                                    Select an option
                                                                </option>
                                                                {boardList.map((option) => (
                                                                    <option key={option.id} value={option.id}>
                                                                        {option.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                        <div className="col-md-4 col-sm-12">
                                                            <div class="form-group">
                                                                <label for="selectInput">Select Language</label>
                                                                <select
                                                                    class="custom-select form-select rounded-0"
                                                                    id="selectInput"
                                                                    onChange={(e) => {
                                                                        setLanguageName(e.target.value)
                                                                        setClassName("")
                                                                        onLanguageChange(e.target.value)
                                                                    }}
                                                                    required
                                                                    value={languageName}
                                                                    name='language_id'
                                                                >
                                                                    <option value="" disabled selected>
                                                                        Select an option
                                                                    </option>
                                                                    {languageList.map((option) => (
                                                                        <option key={option.id} value={option.id}>
                                                                            {option.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4 col-sm-12">
                                                            <div class="form-group">
                                                                <label for="selectInput">Select Class</label>
                                                                <select
                                                                    class="custom-select form-select rounded-0"
                                                                    id="selectInput"
                                                                    onChange={(e) => {
                                                                        setClassName(e.target.value)
                                                                    }}
                                                                    required
                                                                    value={className}
                                                                    name='class_id'
                                                                >
                                                                    <option value="" disabled selected>
                                                                        Select an option
                                                                    </option>
                                                                    {classList.map((option) => (
                                                                        <option key={option.id} value={option.id}>
                                                                            {option.name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </>}

                                                <div className="col-md-12 col-sm-12">
                                                    <div class="form-group">
                                                        <label htmlFor="classInput">Choose an image</label>
                                                        <div class="input-group">
                                                            <input type="file" accept="image/*" ref={imageFileInputRef} onChange={(e) => setImageFile(e.target.files[0])} required={true} />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                            {/* /.card */}
                        </div>
                        {/*/.col (right) */}
                    </div>
                    {/* /.row */}
                </section >



                <section className="content mt-4">
                    <div className="container-fluid">
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <MaterialTable
                                icons={tableIcons}
                                title="Gallery List"
                                columns={columns}
                                data={data}
                                onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
                                options={{
                                    exportButton: true,
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        backgroundColor: 'rgb(0 123 255)',
                                        color: '#FFF',
                                        fontSize: 18
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: (selectedRow === rowData.tableData.id) ? '#d3d4d1' : index % 2 !== 0 ? '#EEE' : '#FFF'
                                    }),
                                }}
                            // actions={[
                            //     {
                            //         icon: () => <span style={{ color: '#5656ce' }}><Edit /></span>,
                            //         tooltip: 'Edit',
                            //         onClick: (event, rowData) => handleEdit(rowData),
                            //     },
                            //     rowData => ({
                            //         icon: () => <span style={{ color: '#5656ce' }}><Delete /></span>,
                            //         tooltip: 'Delete',
                            //         onClick: (event, rowData) => handleDelete(rowData),
                            //     })
                            // ]}
                            />
                        </ThemeProvider>
                    </div>
                </section>

            </div>
        </div>
    )
}

export default QuizImage